/* some imports */
import catalog from './catalog'

export default {
  /* some exports */
  ...catalog,
}
